/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
'external_link': {
    width: 10,
    height: 10,
    viewBox: '0 0 10 10',
    data: `
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_5044_184)">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.62712 0.546463C8.80463 0.723974 8.80463 1.01178 8.62712 1.18929L2.842 6.97441C2.66449 7.15192 2.37668 7.15192 2.19917 6.97441C2.02166 6.7969 2.02166 6.5091 2.19917 6.33159L7.9843 0.546463C8.16181 0.368952 8.44961 0.368952 8.62712 0.546463Z" fill="#005399"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.68604 0.867876C2.68604 0.616837 2.88954 0.41333 3.14058 0.41333H8.30587C8.55691 0.41333 8.76042 0.616837 8.76042 0.867876V6.03316C8.76042 6.2842 8.55691 6.48771 8.30587 6.48771C8.05483 6.48771 7.85132 6.2842 7.85132 6.03316V1.32242H3.14058C2.88954 1.32242 2.68604 1.11891 2.68604 0.867876Z" fill="#005399"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 9.13216C0 8.88112 0.203507 8.67761 0.454545 8.67761H9.54545C9.79649 8.67761 10 8.88112 10 9.13216C10 9.3832 9.79649 9.5867 9.54545 9.5867H0.454545C0.203507 9.5867 0 9.3832 0 9.13216Z" fill="#005399"/>
        </g>
        <defs>
        <clipPath id="clip0_5044_184">
            <rect width="10" height="10" fill="white"/>
        </clipPath>
        </defs>
    </svg>
    `
}
})